import { Card, NeutralTag, SuccessTag, Text } from "@certn/cascadia-react";
import { css } from "@emotion/css";
import { useTranslation } from "react-i18next";

import { BillingProfilesActionDropdownMenu } from "../components/BillingProfilesActionsDropdownMenu";

interface Props {
  billingProfileName: string;
  billingProfileId: string;
  archived: boolean;
}
export function BillingProfileDetailsHeadingCard({
  billingProfileName,
  billingProfileId,
  archived,
}: Props) {
  const { t } = useTranslation();

  return (
    <Card className={styles.card} testID="billing-profile-details-heading-card">
      <div className={styles.container}>
        <Text style="card/title-large" testID="billing-profile-details-name">
          {billingProfileName}
        </Text>
        <div className={styles.trailing}>
          {archived ? (
            <NeutralTag type="subtle">{t("Archived")}</NeutralTag>
          ) : (
            <SuccessTag type="subtle">{t("Active")}</SuccessTag>
          )}
          <BillingProfilesActionDropdownMenu
            profileId={billingProfileId || ""}
            archived={archived}
          />
        </div>
      </div>
    </Card>
  );
}

const styles = {
  card: css({
    padding: "var(--space-4)",
    display: "flex",
    flexDirection: "column",
    gap: "var(--space-4)",
    borderRadius: "var(--border-radius-3)",
  }),
  container: css({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  }),
  trailing: css({
    display: "flex",
    alignItems: "center",
    gap: "var(--space-2)",
  }),
};
